const accessRequestManager = {
  page: {
    title: "Aðgangsbeiðnir",
    subtitle: "Farðu yfir og samþykktu aðgangsbeiðnir frá rannsakendum",
  },
  errors: {
    loadFailed: "Ekki tókst að sækja gögn",
    selectProjectRequired: "Veldu verkefni",
    approveFailed: "Ekki tókst að samþykkja beiðni",
    rejectFailed: "Ekki tókst að hafna beiðni",
  },
  empty: {
    noRequests: "Engar aðgangsbeiðnir í bið",
  },
  statusBadge: {
    awaitingEmailVerification: "Bíður staðfestingar netfangs",
    pendingReview: "Bíður yfirferðar",
  },
  card: {
    email: "Netfang:",
    institution: "Stofnun:",
    projectInterest: "Áhugi á verkefni:",
    requested: "Beðið um: {{date}}",
    newUser: "Nýr notandi",
    mustVerifyEmail: "Notandi þarf fyrst að staðfesta netfang",
    previousRejections: "Fyrri höfnun:",
  },
  actions: {
    approve: "Samþykkja",
    processing: "Vinnur úr...",
    reject: "Hafna",
  },
  approveDialog: {
    title: "Samþykkja aðgangsbeiðni",
    user: "Notandi:",
    email: "Netfang:",
    assignToProject: "Úthluta á verkefni *",
    selectProjectPlaceholder: "Veldu verkefni...",
    role: "Hlutverk *",
    roleResearcher: "Rannsakandi",
    rolePi: "Ábyrgðarmaður (PI)",
    notes: "Athugasemdir (valfrjálst)",
    notesPlaceholder: "Valfrjálsar athugasemdir við samþykki...",
    approve: "Samþykkja",
    approving: "Samþykkir...",
    cancel: "Hætta við",
  },
  rejectDialog: {
    title: "Hafna aðgangsbeiðni",
    user: "Notandi:",
    email: "Netfang:",
    reason: "Ástæða höfnunar (valfrjálst)",
    reasonPlaceholder: "Útskýrðu hvers vegna þessari beiðni er hafnað...",
    reject: "Hafna",
    rejecting: "Hafnar...",
    cancel: "Hætta við",
  },
};

export default accessRequestManager;
